import { createPuzzleLevelStore } from "../modules/puzzle-level-store"
import { getPuzzleById } from "./puzzles"

export const sortaballs10ColorsLevelStore = createPuzzleLevelStore({
  fallbackId: 1,
  isValid: id=> getPuzzleById(id) !== undefined,
  storageKey: "sortaballs-10-colors-current-puzzle-id",
})